import Api from '../api';
import _ from 'lodash';
import {isLocal} from '../../util/env';
import config from '../../config';

const ExtType = {
    device: 'device',
    ext: 'ext'
};

class ExtensionCloud {
    /**
     * @memberof ExtensionCloud
     */
    constructor() {
        this.localExtList = {};
        this.extractPath = './exts/';
    }

    static getInstance() {
        if (!ExtensionCloud.instance) {
            ExtensionCloud.instance = new ExtensionCloud();
        }
        return ExtensionCloud.instance;
    }

    async getExtList(type) {
        // TODO: 有些硬编码
        let extData = {};
        try {
            if (config.enableRemoteExts && !isLocal()) {
                extData = await Api.Extension.getNewRemoteExtList('latest', type);
            } else {
                extData = await fetch(`exts/${type}.json`).then(data => data.json());
            }
            if (!_.has(this.localExtList, type)) {
                this.localExtList[type] = extData;
            }
        } catch (error) {
            console.log({ 'getExtList Err:': error });
        }
        return this.localExtList[type] || [];
    }

    getExt(id) {
        let ext = null;
        for (const key in ExtType) {
            let exts = this.localExtList[ExtType[key]];
            ext = _.find(exts, (item) => item.id === id);
            if (ext) {
                if (isLocal()) {
                    this.extractPath = './exts/';
                    return;
                }
                if(ext.extractPath) {
                    this.extractPath = ext.extractPath;
                }
                break;
            }
        }
        return ext;
    }
}

let extensionCloud = ExtensionCloud.getInstance();

export default extensionCloud;